import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container,
  useTheme,
  useMediaQuery,
  ListItemIcon,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import CalculateIcon from '@mui/icons-material/Calculate';
import { Link } from 'react-router-dom';
import EnquiryForm from './EnquiryForm';

const navItems = [
  { title: 'Home', path: '/', icon: <HomeIcon /> },
  { title: 'About Us', path: '/about', icon: <InfoIcon /> },
  { title: 'Home Loan', path: '/home-loan', icon: <HomeWorkIcon /> },
  { title: 'Loan EMI Calculator', path: '/calculator', icon: <CalculateIcon /> },
];

function Navbar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleEnquiryOpen = () => {
    setIsEnquiryOpen(true);
    setIsDrawerOpen(false);
  };

  const handleEnquiryClose = () => {
    setIsEnquiryOpen(false);
  };

  const drawer = (
    <Box
      sx={{
        width: 250,
        bgcolor: 'background.paper',
        height: '100%',
        pt: 2,
      }}
      role="presentation"
      onClick={handleDrawerToggle}
    >
      <Typography
        variant="h6"
        sx={{
          color: 'primary.main',
          fontWeight: 'bold',
          px: 2,
          mb: 3,
        }}
      >
        Aaradhya Finance
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.title}
            component={Link}
            to={item.path}
            sx={{
              color: 'text.primary',
              '&:hover': {
                bgcolor: 'action.hover',
                color: 'primary.main',
              },
            }}
          >
            <ListItemIcon sx={{ color: 'inherit' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        ))}
        <ListItem sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleEnquiryOpen}
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
            }}
          >
            Apply Now
          </Button>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="sticky" sx={{ bgcolor: 'white' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              component={Link}
              to="/"
              sx={{
                flexGrow: 1,
                textDecoration: 'none',
                color: 'primary.main',
                fontWeight: 'bold',
                fontSize: { xs: '1.2rem', md: '1.5rem' },
              }}
            >
              <img
                src="/images/aaradhya-logo.png"
                alt="Aaradhya Finance Logo"
                style={{ height: '40px' }}
              />
            </Typography>

            {isMobile ? (
              <IconButton
                edge="start"
                color="primary"
                aria-label="menu"
                onClick={handleDrawerToggle}
                sx={{
                  border: 1,
                  borderColor: 'primary.main',
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: 'white',
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                {navItems.map((item) => (
                  <Button
                    key={item.title}
                    component={Link}
                    to={item.path}
                    sx={{ 
                      color: 'primary.main',
                      '&:hover': { color: 'secondary.main' }
                    }}
                  >
                    {item.title}
                  </Button>
                ))}
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ ml: 2 }}
                  onClick={handleEnquiryOpen}
                >
                  Apply Now
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
      >
        {drawer}
      </Drawer>

      <EnquiryForm 
        open={isEnquiryOpen} 
        onClose={handleEnquiryClose} 
      />
    </>
  );
}

export default Navbar; 